import { render, staticRenderFns } from "./AssignAnalysts.vue?vue&type=template&id=2d0b0a00&scoped=true"
import script from "./AssignAnalysts.vue?vue&type=script&lang=js"
export * from "./AssignAnalysts.vue?vue&type=script&lang=js"
import style0 from "./AssignAnalysts.vue?vue&type=style&index=0&id=2d0b0a00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0b0a00",
  null
  
)

export default component.exports